export const DOCUMENT_BASE_TITLE = 'NexMarket - Catálogo de serviços aeronáuticos'
